import { Button, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

import { paths } from '@/routes/paths'

export function NotFoundPage() {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: '70vh', textAlign: 'center' }}
    >
      <Typography variant="overline" color="primary.light">
        Error 404
      </Typography>
      <Typography variant="h3">Página no encontrada</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
        La ruta solicitada no existe o fue movida. Verifica la URL o vuelve al panel principal.
      </Typography>
      <Button component={Link} to={paths.dashboard} variant="contained">
        Volver al dashboard
      </Button>
    </Stack>
  )
}
